import React from 'react';
import { Button } from 'react-bootstrap';
import { ClientApproval, ClientRejection } from '../../API/JobApproval';

export default ({ rl, jobId, approval }) => {
    const Approve = () => {
        ClientApproval(parseInt(jobId))
            .then(res => {
                if (res.success) {
                    rl()
                }
            })
    }

    const Reject = () => {
        ClientRejection(parseInt(jobId))
            .then(res => {
                if (res.success) {
                    rl()
                }
            })
    }

    return (
        <div className="mb-3">
            <div className="row">            
            </div>
            <div className="row">
                <div className="col">
                    {approval.jobApprovalId === 0 ? 
                    "No Approval" : approval.approval ? 
                    `Approval Logged by: ${approval.approver} on ${approval.approvalDate}` : 
                    `Client Denied Approval - Logged by: ${approval.approver} on ${approval.approvalDate}`}
                </div>
            </div>
            {approval.edit &&
                <div className="row">
                    <div className="col text-right">
                        <Button className="enc-button mr-1" onClick={Reject}>Reject</Button>
                        <Button className="enc-button" onClick={Approve}>Approve</Button>
                    </div>
                </div>
            }
        </div>
    )
}
